export const dataShoab = "DATA_SHOAB";
export const dataContact = "DATA_CONTACT";
export const dataOffice = "DATA_OFFICE";
